import React from "react";
import './App.css';
//import necessary to change pages, I will use more than one page so instead display everything what is in app.js
//i can switch between pages, and they are connected to the "allPages.js".
import {Routes, Route} from "react-router-dom";
import {
    LoginAdminPage,
    PayPage,
    HelpPage,
    DestinationPage,
    CustomerCreateOrDisplay,
    CustomerPickListsToDisplay,
    CustomerAddItemUsingCamera,
    CustomerAddItemUsingCameraCustomModel,
    LogoutJWT

} from "./allPages";
import NavbarHome from "./components/NavbarHome";
import HomeV2 from "./componentsV2/HomeV2";
import NotFound from "./componentsV2/NotFound";
import RegisterPageV2 from "./componentsV2/RegisterPageV2";
import LoginPageV2 from "./componentsV2/LoginPageV2";
import CreateCustomerListV2 from "./componentsV2/CreateCustomerListV2";
import DisplayTravelerListV2 from "./componentsV2/DsiplayTravelerListV2";
import DisplayTravelerListV2CustomModel from "./componentsV2/DisplayTravelerListV2CustomModel"
import UserWelcomeForm from "./componentsV2/UserWelcomeForm";



/*
SmartLuggage Application
27.07.2024
Marek Augustyn
*/


function App() {


    return (
        <div>

            <NavbarHome/>
            <Routes>
                {/*<Route path='/' element={Home()}/>*/}
                {/*New route to home homeV2*/}
                <Route path='/' element={<HomeV2/>}/>

                {/*Register*/}
                {/*<Route path='/Register' element={RegisterPage()}/>*/}
                <Route path='/Register' element={<RegisterPageV2/>}/>

                {/*Route with the form */}
                <Route path='/WelcomeForm' element={<UserWelcomeForm/>}/>


                {/*<UserContext.Provider value="Hello from context should diplay on thus three pages">*/}
                {/*It is routed to the allPages.js and there is a function loginPage use to Log in*/}
                <Route path='/Login' element={<LoginPageV2/>}/>
                {/*CreateCustomerList*/}
                <Route path='/CreateCustomerList' element={<CreateCustomerListV2/>}/>
                {/*DisplayList*/}
                <Route path='/displayList' element={<DisplayTravelerListV2/>}/>
                {/*At the moment testing*/}
                <Route path='/displayListCustomModel' element={<DisplayTravelerListV2CustomModel/>}/>
                {/*<Route path='/displayList' element={<DisplayListFuctionalComponentV2/>}/>*/}
                {/* Administrator Page, Display All Contacts, And Manage Database*/}
                <Route path='/LoginAdminPage' element={LoginAdminPage()}/>
                <Route path='/pay' element={PayPage()}/>

                {/*<Route path='/*' element={PageNotExist()}/>*/}
                <Route path='/help' element={HelpPage()}/>
                <Route path='/destination' element={DestinationPage()}/>
                <Route path='/createOrDisplayList' element={CustomerCreateOrDisplay()}/>
                <Route path='/pickListToDisplay' element={CustomerPickListsToDisplay()}/>
                <Route path='/packByUsingCamera' element={CustomerAddItemUsingCamera()}/>
                <Route path='/packByUsingCameraCustomModel' element={CustomerAddItemUsingCamera()}/>
                <Route path='/Logout' element={LogoutJWT()}/>
                <Route path="*" element={<NotFound/>} />

            </Routes>
        </div>

    );
}

export default App;
